import { NonProfitProviderForm } from "@features/JointBillList/components/JointBillPeriod/components/JointBill/components/JointBillTable/components/NonProfitProviders/components/NonProfitProviderRow/components/NonProfitProviderForm/NonProfitProviderForm";
import { type INonProfitProvider } from "@services/nonProfits/types";
import { type IOverviewJointBillService } from "@services/overview/types";
import { formatImageSrc } from "@utils/common";

interface IDonationBillProps {
  jointBillServiceId: IOverviewJointBillService["jointBillServiceId"];
  provider: INonProfitProvider;
  periodId: number;
}

export const NonProfitProviderRow: React.FC<IDonationBillProps> = ({
  jointBillServiceId,
  provider,
  periodId,
}) => {
  return (
    <div
      key={provider.serviceProviderId}
      className="flex flex-col items-center justify-between gap-4 py-4 first:pt-0 last:pb-0 md:flex-row"
    >
      <div className="flex flex-col items-center gap-4 md:flex-row">
        <div className="h-[67px] w-[137px] flex-shrink-0">
          <img
            className="h-full w-full object-contain"
            src={formatImageSrc(provider.logo)}
            alt={provider.logo.fileName}
          />
        </div>
        <p className="w-full font-medium md:max-w-[420px]">
          {provider.description ?? provider.name}
        </p>
      </div>
      <NonProfitProviderForm
        jointBillServiceId={jointBillServiceId}
        provider={provider}
        periodId={periodId}
      />
    </div>
  );
};
